import type { AppState } from 'state/state.model';

export function getAddonManagementFormFieldMetadata(state: AppState, formId: string) {
  return state.addonManagementForm?.metaData.fields[formId];
}
